var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 361,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 361",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m255.554813 70.7657143-23.241143 260.3597367-104.469802 28.962461-104.1821537-28.92167-23.21652749-260.4005277z",
    fill: "#e44d26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m128 337.950242 84.416703-23.403605 19.861099-222.4893183h-104.277802z",
    fill: "#f16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m82.8202198 155.932132h45.1797802v-31.937407h-80.082989l.7644835 8.568264 7.8494945 88.009846h71.469011v-31.936703h-42.2610989z",
    fill: "#ebebeb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m90.0177582 236.54189h-32.0597802l4.4743736 50.145758 65.4206594 18.161231.146989-.040791v-33.227956l-.139956.037275-35.5685275-9.60422z",
    fill: "#ebebeb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24.1807473 0h16.229978v16.0351648h14.8465934v-16.0351648h16.2306813v48.5584176h-16.229978v-16.2602198h-14.8465934v16.2602198h-16.2299781v-48.5584176z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m92.8309451 16.1026813h-14.2881759v-16.1026813h44.8140658v16.1026813h-14.294505v32.4557363h-16.2306816v-32.4557363z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m130.469275 0h16.923428l10.410198 17.061978 10.399648-17.061978h16.929759v48.5584176h-16.163165v-24.0682198l-11.166242 17.2652308h-.279209l-11.173978-17.2652308v24.0682198h-15.880439z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m193.20967 0h16.234901v32.5077802h22.824088v16.0506374h-39.058989z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.889582 220.572835h39.326945l-3.707076 41.419956-35.619869 9.614066v33.22655l65.472704-18.145759.480351-5.395692 7.504879-84.079824.779253-8.576h-74.237187z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.889582 155.854066v.078066h77.143209l.640704-7.17855 1.45512-16.190593.763781-8.568264h-80.002814z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html-5.37bf6863fb717ae4cad4e56f9c291a86.svg";
export { ForwardRef as ReactComponent };